export const LOADING = 'user/LOADING';
export const MESSAGE = 'user/MESSAGE';
export const SET_USERS = 'user/SET_USERS';
export const SET_USER = 'user/SET_USER';
export const SET_GROUPS = 'user/SET_GROUPS';
export const SET_GROUPS_NAME = 'user/SET_GROUPS_NAME';